import PropTypes from 'prop-types';
import React from 'react';

import InputRadio from 'commons-forms/components/InputRadio/InputRadio.jsx';

class InputRadioContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    handleRadioChange(value) {
        this.props.onChange(value, this.props.name);
    }

    render() {
        const options = this.props.options.map((option) => (
            <InputRadio
                {...option}
                name={this.props.name}
                onChange={this.props.onChange}
                isSelected={option.value === this.props.value}
                key={`${this.props.name}-${option.value}`}
                isRequired={option.isRequired}
            />
        ));

        return (
            <div>
                <div className="sr-text is-bold">{this.props.label}</div>
                <div className="radio-button-cta-wrapper">{options}</div>
            </div>
        );
    }
}

InputRadioContainer.defaultProps = {
    options: [],
};

InputRadioContainer.propTypes = {
    label: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            isRequired: PropTypes.bool,
            isSelected: PropTypes.bool,
            label: PropTypes.node.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
        })
    ),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
};

InputRadioContainer.displayName = 'InputRadioContainer';

export default InputRadioContainer;
